export default "__VITE_ASSET__C5Y8nP4o__"